import { render, staticRenderFns } from "./DialogIdeaInfo.vue?vue&type=template&id=3fca63b8&scoped=true"
import script from "./DialogIdeaInfo.vue?vue&type=script&lang=js"
export * from "./DialogIdeaInfo.vue?vue&type=script&lang=js"
import style0 from "./DialogIdeaInfo.vue?vue&type=style&index=0&id=3fca63b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca63b8",
  null
  
)

export default component.exports